import styled from 'styled-components';
import { IconChevronLeft, IconChevronRight, IconDots } from '@tabler/icons-react';
import { Indicator as MantineIndicator, Select as MantineSelect } from '@mantine/core';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0.5rem 1rem 1rem;
  height: 60px;
  @media screen and (max-width: 700px) {
    padding: 1rem 0.5rem;
  }
`;

export const Navigation = styled.div`
  display: flex;
  align-items: center;
`;

export const NavigationArrows = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.div`
  border: 1px solid #ced4da;
  padding: 5px 10px;
  border-radius: 0.25rem;
  margin-left: 1rem;
  height: 35px;
  &:hover {
    cursor: pointer;
    background-color: var(--secondary-button-hover-background-color);
  }
  @media screen and (max-width: 700px) {
    margin-left: 0rem;
  }
`;

export const LeftArrow = styled(IconChevronLeft)`
  margin-right: 5px;
  padding: 5px;
  &:hover {
    cursor: pointer;
    background-color: var(--secondary-button-hover-background-color);
    border-radius: 50%;
  }
`;

export const RightArrow = styled(IconChevronRight)`
  margin-left: 5px;
  padding: 5px;
  &:hover {
    cursor: pointer;
    background-color: var(--secondary-button-hover-background-color);
    border-radius: 50%;
  }
`;

export const DateLabel = styled.label`
  @media screen and (max-width: 700px) {
    font-size: 13px;
  }
`;

export const ViewButtons = styled.div`
  display: flex;
  align-items: center;
`;

interface OptionsIconPropsType {
  $isOptions: boolean;
}

export const Indicator = styled(MantineIndicator)`
  display: flex;
  z-index: 0;
  @media screen and (max-width: 850px) {
    display: none;
  }
`;

export const OptionsIcon = styled(IconDots)<OptionsIconPropsType>`
  padding: 5px;
  margin-left: 10px;
  width: 35px;
  height: 35px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: ${(props) =>
    props.$isOptions ? ' var(--secondary-button-hover-background-color)' : 'none'};
  &:hover {
    background-color: var(--secondary-button-hover-background-color);
    cursor: pointer;
  }
  @media screen and (max-width: 850px) {
    display: none;
  }
`;

export const Select = styled(MantineSelect)`
  width: 105px;

  .mantine-Select-input {
    background-color: var(--app-primary-background-color) !important;
    color: var(--app-primary-text-color);
  }
  .mantine-Select-dropdown {
    background-color: var(--app-primary-background-color) !important;
    color: var(--app-primary-text-color);
  }
`;

export const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
